"use client";

export default function PoliticaCookiePage() {
  return (
    <section className="bg-[#FDF9F5] text-[#264653] py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold mb-4">Politica de cookie-uri</h1>

        <p className="text-[#264653]/80">
          Această politică explică modul în care platforma <strong>Mindtale</strong> utilizează cookie‑uri și tehnologii similare
          (de ex. stocare locală în browser) pentru a oferi funcționalitățile de bază, a păstra preferințe și a îmbunătăți
          experiența ta de navigare.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Ce sunt cookie-urile</h2>
        <p>
          Cookie-urile sunt fișiere text de mici dimensiuni stocate pe dispozitivul tău atunci când
          vizitezi un site web. Acestea permit recunoașterea dispozitivului și optimizarea experienței.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Tipuri de cookie‑uri și stocare utilizate</h2>
        <ul className="list-disc list-inside text-[#264653]/80">
          <li>
            <strong>Esențiale:</strong> necesare pentru funcționarea corectă și sigură a site‑ului. Pot include păstrarea
            temporară a progresului în completarea chestionarului (stocat local pe dispozitivul tău), astfel încât să îți putem
            oferi serviciul solicitat.
          </li>
          <li>
            <strong>Analitice (Analytical):</strong> ne ajută să înțelegem cum este folosit site‑ul și ce putem îmbunătăți
            (ex. Google Analytics).
          </li>
          <li>
            <strong>Preferințe (Preference):</strong> rețin alegerile tale (ex. limbă, setări UI) pentru o experiență
            personalizată.
          </li>
          <li>
            <strong>Marketing:</strong> folosite pentru campanii publicitare și măsurarea performanței acestora, doar cu
            consimțământ (ex. Google Ads, Meta, TikTok).
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. Cum poți gestiona cookie‑urile</h2>
        <p>
          Poți modifica preferințele tale din bannerul de consimțământ sau din secțiunea{" "}
          <strong>Setări cookie</strong> din footer. De asemenea, poți ajusta setările din browserul tău oricând.
          Dezactivarea anumitor cookie‑uri poate afecta funcționalitatea platformei.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Instrumente terțe</h2>
        <p>
          Mindtale poate utiliza servicii precum <strong>Google Analytics</strong> (analitice), <strong>Google Ads</strong>,
          <strong>Meta Pixel</strong> și <strong>TikTok Pixel</strong> (marketing). Aceste servicii sunt activate doar cu
          consimțământul tău și pot colecta date despre interacțiunea cu site‑ul pentru analiză sau publicitate.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Consimțământ</h2>
        <p>
          La prima accesare a site‑ului, vei fi informat despre utilizarea cookie‑urilor și ți se va
          solicita acordul explicit pentru categoriile care nu sunt esențiale. Îți poți modifica oricând
          opțiunile din setările cookie.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Contact</h2>
        <p>
          Pentru întrebări legate de cookie-uri, ne poți contacta la{" "}
          <a href="mailto:hello@mindtale.ro" className="text-[#E76F51] hover:underline">
            hello@mindtale.ro
          </a>.
        </p>
      </div>
    </section>
  );
}
